import { apiService } from '@/services/APIService';

export default {
  loginAsUser(params) {
    return apiService.post('/admin/users/impersonate', params);
  },
  getOrganizationUsers(params) {
    return apiService.get('/admin/users/organization', params);
  },
  getMemberUsers(params) {
    return apiService.get('/admin/users/member', params);
  },
  getExpertUsers(params) {
    return apiService.get('/admin/users/expert', params);
  },
  getTrainerUsers(params) {
    return apiService.get('/admin/users/trainer', params);
  },
  getOperators(params) {
    return apiService.get('/admin/users/operators', params);
  },
  putMemberData(id, params) {
    return apiService.put(`/admin/users/member/${id}`, params);
  },
  putUserLogPass(id, params) {
    return apiService.put(`/admin/users/${id}`, params);
  },
  deleteUserProfile(id, params) {
    return apiService.delete(`/admin/users/${id}`, params);
  },
  putOrganizationData(id, params) {
    return apiService.put(`/admin/users/organization/${id}`, params);
  },
  deleteOrganizationProfile(id, params) {
    return apiService.delete(`admin/users/organization/${id}`, params);
  },
  putExpertData(id, params) {
    return apiService.put(`/admin/users/expert/${id}`, params);
  },
  deleteExpertProfile(id, params) {
    return apiService.delete(`admin/users/expert/${id}`, params);
  },
  putTrainerData(id, params) {
    return apiService.put(`/admin/users/trainer/${id}`, params);
  },
  deleteTrainerProfile(id, params) {
    return apiService.delete(`admin/users/trainer/${id}`, params);
  },
  getAllDuplicates(params) {
    return apiService.get(`admin/users/duplicate`, params);
  },
  getSameDuplicates(id, params) {
    return apiService.get(`admin/users/duplicate/${id}`, params);
  },
};
